export default "__VITE_ASSET__56f478a3__"